import { createAction } from 'redux-actions';
import {
    EXECUTE_SOCKET_ACTION,
    SET_SOCKET_CONNECTION,
    SUBSCRIBE,
    SUBSCRIBE_FAILURE,
    SUBSCRIBE_SUCCESS,
    SUBSCRIBE_TO_PLANNINGBOARD_EVENTS_FAILURE,
    SUBSCRIBE_TO_PLANNINGBOARD_EVENTS_REQUEST,
    SUBSCRIBE_TO_PLANNINGBOARD_EVENTS_SUCCESS,
    UNSUBSCRIBE,
    UNSUBSCRIBE_FAILURE,
    UNSUBSCRIBE_SUCCESS,
    UNSUBSCRIBE_TO_PLANNINGBOARD_EVENTS_FAILURE,
    UNSUBSCRIBE_TO_PLANNINGBOARD_EVENTS_REQUEST,
    UNSUBSCRIBE_TO_PLANNINGBOARD_EVENTS_SUCCESS,
} from './constants';

export const setSocketConnection = createAction(SET_SOCKET_CONNECTION);
export const executeSocketAction = createAction(EXECUTE_SOCKET_ACTION);

export const subscribe = createAction(SUBSCRIBE);
export const subscribeSuccess = createAction(SUBSCRIBE_SUCCESS);
export const subscribeFailure = createAction(SUBSCRIBE_FAILURE);

export const unsubscribe = createAction(UNSUBSCRIBE);
export const unsubscribeSuccess = createAction(UNSUBSCRIBE_SUCCESS);
export const unsubscribeFailure = createAction(UNSUBSCRIBE_FAILURE);

export const subscribeToPlanningBoardEvents = createAction(
    SUBSCRIBE_TO_PLANNINGBOARD_EVENTS_REQUEST,
);
export const subscribeToPlanningBoardEventsSuccess = createAction(
    SUBSCRIBE_TO_PLANNINGBOARD_EVENTS_SUCCESS,
);
export const subscribeToPlanningBoardEventsFailure = createAction(
    SUBSCRIBE_TO_PLANNINGBOARD_EVENTS_FAILURE,
);
export const unsubscribeToPlanningBoardEvents = createAction(
    UNSUBSCRIBE_TO_PLANNINGBOARD_EVENTS_REQUEST,
);
export const unsubscribeToPlanningBoardEventsSuccess = createAction(
    UNSUBSCRIBE_TO_PLANNINGBOARD_EVENTS_SUCCESS,
);
export const unsubscribeToPlanningBoardEventsFailure = createAction(
    UNSUBSCRIBE_TO_PLANNINGBOARD_EVENTS_FAILURE,
);
